import * as React from 'react';
import { View } from 'react-native';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { CardView } from 'design-system/CardView';
import IconDown from 'design-system/icons/IconDown';
import { CurrencyAmountText } from 'design-system/CurrencyAmountText';
import { formatDate, getPriceChangeViewValues, getColorKeyFromPriceTrend, } from 'features/invest/utils/portfolio';
import { useStockMeta, usePriceChange, useCurrentPrice, } from 'features/invest/hooks/selectors';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const WalkthroughStockPriceView = ({ assetId, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const stockCache = useStockMeta(assetId);
    const currentPrice = useCurrentPrice(assetId);
    const priceChangeRaw = usePriceChange(assetId);
    const priceChange = React.useMemo(() => getPriceChangeViewValues(priceChangeRaw?.value, (priceChangeRaw?.percent || 0) * 100, currentPrice?.currency), [currentPrice?.currency, priceChangeRaw?.percent, priceChangeRaw?.value]);
    const infoObj = React.useMemo(() => {
        const color = colors.text[getColorKeyFromPriceTrend(priceChange.priceTrend)];
        if (priceChange.priceTrend === 1) {
            return {
                color,
                Icon: (<View style={styles.upIcon}>
            <IconDown color={colors.text.positive}/>
          </View>),
            };
        }
        if (priceChange.priceTrend === -1) {
            return {
                color,
                Icon: (<View style={styles.iconWidth}>
            <IconDown color={colors.text.negative}/>
          </View>),
            };
        }
        return {
            color,
            Icon: (<View style={styles.iconWidth}>
          <View style={styles.neutralIndicator}/>
        </View>),
        };
    }, [
        colors.text,
        priceChange.priceTrend,
        styles.iconWidth,
        styles.neutralIndicator,
        styles.upIcon,
    ]);
    return (<CardView style={styles.container} noMargin>
      <View style={styles.row}>
        <View style={styles.flex}>
          <Text Text-14 Gray numberOfLines={2}>
            {`${stockCache?.name ?? ''}${stockCache?.symbol ? ` ($${stockCache.symbol})` : ''}`}
          </Text>
          <Spacer h={2}/>
          <CurrencyAmountText size="L" value={{
            amount: currentPrice?.value || 0,
            currency: currentPrice?.currency || 'USD',
        }}/>
        </View>
        <Spacer w={16}/>
        <Logo R46 uri={stockCache?.iconUrl} resizeMode="contain"/>
      </View>
      <View style={styles.row}>
        <View style={styles.arrowView}>{infoObj.Icon}</View>
        <Text NumbersThin-14 color={infoObj.color}>
          {priceChange.priceChangeValue}
        </Text>
        <Spacer w={8}/>
        <Text TextThin-14 Secondary>
          {formatDate(new Date(), false, false)}
        </Text>
      </View>
    </CardView>);
};
export default React.memo(WalkthroughStockPriceView);
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        marginTop: rem(4),
        paddingVertical: rem(16),
        marginHorizontal: rem(4),
        paddingHorizontal: rem(16),
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    walkthroughContainer: {},
    row: {
        flexDirection: 'row',
    },
    arrowView: {
        width: rem(12),
        justifyContent: 'center',
    },
    upIcon: {
        width: rem(7),
        transform: [{ rotate: '180deg' }],
    },
    iconWidth: {
        width: rem(7),
    },
    neutralIndicator: {
        width: rem(6),
        height: rem(6),
        borderRadius: rem(6),
        backgroundColor: colors.text.secondary,
    },
    flex: {
        flex: 1,
    },
}));
